import { ActionTree } from 'vuex';
import { HistoryState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { AddQueryHistoryAction } from './actions/add-query-history.action';
import { AddSessionQueryHistoryAction } from './actions/add-session-query-history.action';
import { ClearQueryHistoryAction } from './actions/clear-query-history.action';
import { ClickedResultHistoryAction } from './actions/clicked-result-history.action';
import { LoadQueryHistoryAction } from './actions/load-query-history.action';
import { LoadSessionQueryHistoryAction } from './actions/load-session-query-history.action';
import { RemoveQueryHistoryAction } from './actions/remove-query-history.action';
import { SetEnabledQueryHistoryAction } from './actions/set-enabled-query-history.action';

export const HISTORY_ACTIONS: ActionTree<HistoryState, RootStoreState> = {
  ...new AddQueryHistoryAction().actions,
  ...new AddSessionQueryHistoryAction().actions,
  ...new ClearQueryHistoryAction().actions,
  ...new ClickedResultHistoryAction().actions,
  ...new LoadQueryHistoryAction().actions,
  ...new LoadSessionQueryHistoryAction().actions,
  ...new RemoveQueryHistoryAction().actions,
  ...new SetEnabledQueryHistoryAction().actions,
};
